import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Vimeo from '@u-wave/react-vimeo';

export const VimeoVideoDossier = props =>

  <section>
    <div className="row">
      <div className="col-lg-12">
        <div className="full-width">
          <Vimeo
            video={props.content.fieldVideoVimeo}
            responsive
            controls={true}
          />
        </div>
      </div>
    </div>

  </section>
;

VimeoVideoDossier.propTypes = {
  content: PropTypes.object.isRequired,
};
